module.exports = __webpack_public_path__ + "img/个性化定制背景.3799c612.png";